/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Tags_Manager_Remove_Failed_ToastInputs */

const en_tags_manager_remove_failed_toast = /** @type {(inputs: Tags_Manager_Remove_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to delete tag set: ${i?.error}`)
};

const fr_tags_manager_remove_failed_toast = /** @type {(inputs: Tags_Manager_Remove_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de la suppression de l'ensemble de tags : ${i?.error}`)
};

const de_tags_manager_remove_failed_toast = /** @type {(inputs: Tags_Manager_Remove_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tag-Set konnte nicht gelöscht werden: ${i?.error}`)
};

const it_tags_manager_remove_failed_toast = /** @type {(inputs: Tags_Manager_Remove_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile eliminare il set di tag: ${i?.error}`)
};

const ru_tags_manager_remove_failed_toast = /** @type {(inputs: Tags_Manager_Remove_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось удалить набор тегов: ${i?.error}`)
};

const es_tags_manager_remove_failed_toast = /** @type {(inputs: Tags_Manager_Remove_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo eliminar el conjunto de etiquetas: ${i?.error}`)
};

const zh_cn2_tags_manager_remove_failed_toast = /** @type {(inputs: Tags_Manager_Remove_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`删除标签集失败：${i?.error}`)
};

const ja_tags_manager_remove_failed_toast = /** @type {(inputs: Tags_Manager_Remove_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`タグセットの削除に失敗しました: ${i?.error}`)
};

const hi_tags_manager_remove_failed_toast = /** @type {(inputs: Tags_Manager_Remove_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`टैग सेट ${i?.error} को हटाने में विफल रहा`)
};

const pt_pt2_tags_manager_remove_failed_toast = /** @type {(inputs: Tags_Manager_Remove_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao excluir o conjunto de tags: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to delete tag set: {error}" |
*
* @param {Tags_Manager_Remove_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_remove_failed_toast = /** @type {((inputs: Tags_Manager_Remove_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Remove_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_remove_failed_toast(inputs)
	if (locale === "de") return de_tags_manager_remove_failed_toast(inputs)
	if (locale === "it") return it_tags_manager_remove_failed_toast(inputs)
	if (locale === "ru") return ru_tags_manager_remove_failed_toast(inputs)
	if (locale === "es") return es_tags_manager_remove_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_remove_failed_toast(inputs)
	if (locale === "ja") return ja_tags_manager_remove_failed_toast(inputs)
	if (locale === "hi") return hi_tags_manager_remove_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_remove_failed_toast(inputs)
	return en_tags_manager_remove_failed_toast(inputs)
});